import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getDashboardAlertas (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getFinancialDashboardRecibidas)
      }, 500)
    })
  } else {
    const req = {
      url: '/api/dashboard/getdashboardalerts',
      method: 'GET',
      params,
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      }
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getDashboardAlertas }
